<template>
  <div
    v-bind:class="{ home: true, 'blue-bg': blueBg, 'style2-bg': style != 1 }"
    v-if="cookieEnabled"
  >
    <scanUI v-if="platform != 0 && showScanUI"></scanUI>
    <downLoadApp
      @notice="noticeShowHowDownLoadApp"
      ref="downLoadAppIcon"
      v-if="showDownLoadAppIcon"
    ></downLoadApp>
    <howDownLoadApp
      @noticeClose="handleClose()"
      v-if="showHowDownLoadApp"
    ></howDownLoadApp>
    <a
      href="javascript:void(0)"
      class="animated fadeIn down-app"
      v-show="showDownLoadAppIcon"
    ></a>
    <iframe
      id="iframeHall"
      ref="iframeHall"
      scrolling="no"
      frameborder="0"
      :height="ifmHeight"
      v-bind:class="{ 'ifm ifm1': true, gaussianBlur: gaussianBlur }"
      :src="hallIfmUrl"
      :style="Object.assign({ 'z-index': hallZIndex }, styles.default)"
      allow="accelerometer *; gyroscope *; magnetometer *; geolocation *; fullscreen *; autoplay *"
    ></iframe>
    <iframe
      id="iframeGame"
      ref="iframeGame"
      scrolling="no"
      frameborder="0"
      :height="ifmHeight"
      :src="gameIfmUrl"
      v-bind:class="{ 'ifm ifm2': true, gaussianBlur: gaussianBlur }"
      :style="Object.assign({ 'z-index': gameZIndex }, styles.default)"
      allow="accelerometer *; gyroscope *; magnetometer *; geolocation *; fullscreen *; autoplay *"
    ></iframe>
    <iframe
      id="iframeAct"
      ref="iframeAct"
      scrolling="no"
      frameborder="0"
      :height="ifmHeight"
      :src="actIfmUrl"
      v-bind:class="{ 'ifm ifm3': true, gaussianBlur: gaussianBlur }"
      :style="Object.assign({ 'z-index': actZIndex }, styles.default)"
      allow="accelerometer *; gyroscope *; magnetometer *; geolocation *; fullscreen *; autoplay *"
    ></iframe>
    <snow v-bind="snowConf" :show="showSnow && theme == 'newYear'"></snow>
    <snow v-bind="flakeConf" :show="showSnow && theme == 'newYear'"></snow>
    <snow
      v-bind="newYear2020Conf1"
      :show="showSnow && theme == 'newYear2020'"
    ></snow>
    <snow
      v-bind="newYear2020Conf2"
      :show="showSnow && theme == 'newYear2020'"
    ></snow>
    <snow v-bind="zhongqiuConf" :show="showSnow && theme == 'zhongqiu'"></snow>
    <snow v-bind="zhongqiuCon2" :show="showSnow && theme == 'zhongqiu'"></snow>
    <luckyWheel
      v-if="showLuckyWheelEntrance && canShowLuckyWheelEntrance"
    ></luckyWheel>
  </div>
  <div v-else class="tips-nocookie">
    <p>您的cookie可能已经被禁用，请到浏览器设置中关闭该选项。</p>
    <p @click="handleReload" class="link">如果您已启用cookie，请点击此处刷新</p>
  </div>
</template>

<script>
import scanUI from "./scanUI.vue";
import howDownLoadApp from "@/components/howDownLoadApp.vue";
import downLoadApp from "@/components/downLoadApp.vue";
import luckyWheel from "@/components/luckyWheel.vue";
import { mapState } from "vuex";
import App from "@/logic/entrance";
import Browser from "@/utils/browser.js";
import snow from "@/components/snow.vue";
import { reportUserBehavior } from "@/logic/src/common";
import { iPadAdapter } from "@/utils/ui.js";

// import DialogNotice from '@/packages/dialogNotice/index.js';

const brow = new Browser();
const ratio = 1280 / 720;
export default {
  name: "home",
  components: {
    scanUI,
    howDownLoadApp,
    downLoadApp,
    snow,
    luckyWheel,
  },
  computed: {
    ...mapState({
      hallIfmUrl: (state) => state.app.hallIfmUrl,
      gameIfmUrl: (state) => state.app.gameIfmUrl,
      actIfmUrl: (state) => state.app.actIfmUrl,
      ifmHeight: (state) => state.app.ifmHeight,
      ifmWidth: (state) => state.app.ifmWidth,
      hallZIndex: (state) => state.app.hallZIndex,
      gameZIndex: (state) => state.app.gameZIndex,
      actZIndex: (state) => state.app.actZIndex,
      showDownLoadAppIcon: (state) => state.app.showDownLoadAppIcon,
      blueBg: (state) => state.app.blueBg,
      platform: (state) => state.app.platform,
      showScanUI: (state) => state.app.showScanUI,
      iPadMode: (state) => state.app.iPadMode,
      showSnow: (state) => state.app.showSnow,
      theme: (state) => state.app.theme,
      style: (state) => state.app.style,
      gaussianBlur: (state) => state.app.gaussianBlur,
      currentGameID: (state) => state.app.currentGameID,
      showLuckyWheelEntrance: (state) => state.app.showLuckyWheelEntrance,
      canShowLuckyWheelEntrance: (state) => state.app.canShowLuckyWheelEntrance,
    }),
  },
  data() {
    return {
      showHowDownLoadApp: false,
      styles: {
        default: {},
      },
      snowConf: {
        windPower: -3,
        speed: 0.1,
        count: 20,
        size: 5,
        images: [require("@/assets/img/christmas/snow.png")],
      },
      flakeConf: {
        windPower: 2,
        speed: 0.1,
        count: 250,
        size: 0,
      },
      newYear2020Conf1: {
        windPower: -2,
        speed: brow.isMobile() ? 0 : 0.2,
        count: brow.isMobile() ? 10 : 15,
        size: brow.isMobile() ? 13 : 20,
        images:
          brow.getDirection() == "vertical" && brow.isMobile()
            ? [require("@/assets/img/theme/new-year-2020/2020-2-1.png")]
            : [require("@/assets/img/theme/new-year-2020/2020-2.png")],
      },
      newYear2020Conf2: {
        windPower: -4,
        speed: brow.isMobile() ? 0 : 0.2,
        count: brow.isMobile() ? 3 : 5,
        size: brow.isMobile() ? 13 : 20,
        images:
          brow.getDirection() == "vertical" && brow.isMobile()
            ? [require("@/assets/img/theme/new-year-2020/2020-1-1.png")]
            : [require("@/assets/img/theme/new-year-2020/2020-1.png")],
      },
      zhongqiuConf: {
        windPower: -4,
        speed: brow.isMobile() ? 0 : 0.2,
        count: brow.isMobile() ? 3 : 5,
        size: brow.isMobile() ? 13 : 20,
        images:
          brow.getDirection() == "vertical" && brow.isMobile()
            ? [require("@/assets/img/theme/zhongqiu/3-1.png")]
            : [require("@/assets/img/theme/zhongqiu/3.png")],
      },
      zhongqiuCon2: {
        windPower: -2,
        speed: brow.isMobile() ? 0 : 0.2,
        count: brow.isMobile() ? 10 : 15,
        size: brow.isMobile() ? 13 : 20,
        images:
          brow.getDirection() == "vertical" && brow.isMobile()
            ? [require("@/assets/img/theme/zhongqiu/4-1.png")]
            : [require("@/assets/img/theme/zhongqiu/4.png")],
      },
      cookieEnabled: window.Storage && window.localStorage && window.localStorage instanceof Storage,
    };
  },
  watch: {
    iPadMode(val) {
      const iPadVertical = {
        top: "0%",
        left: `${
          ((1 - window.innerHeight / ratio / window.innerWidth) / 2) * 100
        }%`,
        width: `${(window.innerHeight / ratio / window.innerWidth) * 100}%`,
        height: "100%",
      };
      const iPadHorizontal = {
        top: `${
          ((1 - window.innerWidth / ratio / window.innerHeight) / 2) * 100
        }%`,
        left: "0%",
        width: "100%",
        height: `${(window.innerWidth / ratio / window.innerHeight) * 100}%`,
      };
      const horizontalSuperWide = {
        top: "0%",
        left: `${
          ((1 - (window.innerHeight * ratio) / window.innerWidth) / 2) * 100
        }%`,
        width: `${((window.innerHeight * ratio) / window.innerWidth) * 100}%`,
        height: "100%",
      };
      if (val.key == "vertical") {
        this.styles.default = iPadVertical;
      } else if (val.key == "horizontal") {
        this.styles.default = iPadHorizontal;
      } else if (val.key == "horizontalSuperWide") {
        this.styles.default = horizontalSuperWide;
      } else {
        this.styles.default = {};
      }
    },
    currentGameID() {
      iPadAdapter();
    },
  },
  mounted() {
    const app = new App({});
    app.init();
    this.initBodyClick();
    reportUserBehavior(999, 0, 8000, 20);

    // window.__dialogNotice = DialogNotice.service({
    //   data: [],
    //   userKey: 1,
    //   gameID: 1001,
    //   style: 2,
    // });

    // var vc = new vConsole();
    // vc.setSwitchPosition(20, 20);
    //this.$dialogNotice({style:0});
    //this.$couplet();
    //this.$touchFullSceen();
    // this.$dialogHelp({
    //   gameId: 4001,
    //   lang: "cn",
    //   style: 2
    // });
    // window.setTimeout(() => {
    //   this.$dialogHelp({
    //     gameId: 1053,
    //     lang: "cn",
    //     style: 1,
    //   });
    // }, 2000);

    // this.$preLoading({
    //   text: "加载中",
    //   showLogo: true
    // });
  },
  methods: {
    handleReload() {
      window.location.reload();
    },
    initBodyClick() {
      if (!brow.isMobile()) {
        let events = ["click", "mousedown", "mouseup", "mouseout"];
        for (const i in events) {
          document.body.addEventListener(events[i], () => {
            if (this.gameZIndex == 4) {
              this.$refs.iframeGame && this.$refs.iframeGame.focus();
            } else {
              this.$refs.iframeHall && this.$refs.iframeHall.focus();
            }
          });
        }
      }
    },
    handleClose() {
      this.showHowDownLoadApp = false;
      this.$refs.downLoadAppIcon.closePop();
    },
    noticeShowHowDownLoadApp() {
      this.showHowDownLoadApp = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.home {
  height: 100%;
  width: 100%;
  color: #ffffff;
  font-size: 0.12rem;
  &.blue-bg {
    background-color: #104777;
  }
  &.style2-bg {
    background-color: #ffffff;
  }
  .ifm {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    &.ifm1 {
      z-index: -1;
    }
    &.ifm2 {
      z-index: 2;
    }
    &.ifm3 {
      z-index: 3;
    }
  }
  .gaussianBlur {
    filter: blur(0.025rem);
  }
}
.tips-nocookie {
  font-size: 0.12rem;
  color: #ffffff;
  text-align: center;
  height: 100%;
  background-color: #104777;
  p {
    padding-top: 0.15rem;
    &.link {
      cursor: pointer;
    }
  }
}
</style>
